// Audited against the sibling DriverController/DriverService, not deployment feature flags.
// Legacy endpoints exist, but dispatch eligibility, expected versions, recoverable operations
// and complete evidence requirements are absent. An endpoint alone is not permission to enable it.
export const driverCapabilities = Object.seal({
 accept: false, pickup: false, complete: false, cancellation: false,
 location: false, maskedContact: false, cashCollection: false,
 earnings: false, ledger: false, payouts: false,
});
export const DRIVER_TRIP_UNAVAILABLE = 'Trip actions are currently unavailable. Dispatch eligibility, evidence validation and safe operation recovery must be confirmed before accepting, picking up or completing a trip.';
export class DriverFeatureUnavailable extends Error {
 constructor(feature) { super(feature + ' is currently unavailable.'); this.code='DRIVER_FEATURE_UNAVAILABLE'; }
}
export function requireDriverCapability(feature) {
 if(driverCapabilities[feature]!==true)throw new DriverFeatureUnavailable(feature);
}
/** @type {import('../types/driverPartner').DriverFinancialServices} */
export const driverFinancialServices = {
 earnings: async()=>{throw new DriverFeatureUnavailable('Earnings');},
 ledger: async()=>{throw new DriverFeatureUnavailable('Ledger');},
 payouts: async()=>{throw new DriverFeatureUnavailable('Payouts');},
 requestPayout: async()=>{throw new DriverFeatureUnavailable('Payout requests');},
};

export function applyDriverCapabilities(response){
 const capabilities=response?.data||response;
 const legacy=response?.capabilities?.tripActions==='OTP_RECOVERY_V1';
 const enabled=capabilities?.tripActions?.enabled===true||legacy;
 Object.assign(driverCapabilities,{cancellation:enabled||capabilities?.offers?.enabled===true,accept:capabilities?.offers?.enabled===true||legacy,pickup:enabled,complete:enabled,cashCollection:capabilities?.cashCollections?.enabled===true||(legacy&&response?.capabilities?.cashCollection==='CASH_RECEIPT_V1')});
}
